import React,{useEffect,useState} from 'react'
import blogs from '../../api/blogs'
import SectionTitle3 from '../SectionTitle3'
import {Link} from 'react-router-dom'
import bShape1 from '../../images/blog/Vector3.png'
import bShape2 from '../../images/blog/Vector4.png'
 
import {  collection, getDocs, query, orderBy, limit,db } from '../../api/firebaseConfig.js'

const BlogSectionS2 = (props) => {
    const [posts, setPosts] = useState([]);
    const truncateDescription = (description) => {
        if (description.length > 100) {
          return description.slice(0, 100) + "...";
        }
        return description;
      };
      useEffect(() => {
        const fetchPosts = async () => {
          try {
            // Query to get the latest 3 posts sorted by createdAt field (descending)
            const q = query(
              collection(db, "blogPosts"),
              orderBy("createdAt", "desc"),
              limit(3)
            );
            
            const querySnapshot = await getDocs(q);
            const postsList = querySnapshot.docs.map((doc) => {
              const post = doc.data();
              return {
                id: doc.id,
                imageprincipale: post.imageprincipale,
                title: post.title,
                description: truncateDescription(post.description),
                createdAt: post.createdAt.toDate().toLocaleDateString(), // Format the date
              };
            });
            // console.log(postsList)
            setPosts(postsList);
          } catch (error) {
            console.error("Error fetching posts: ", error);
          }
        };
        fetchPosts();
      }, []);

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

    return(

        <section className="wpo-blog-section-s2 section-padding" id="blog">
            <div className="container">
                <SectionTitle3 subTitle={'Nos Projets'} MainTitle={'Nos Réalisations Récentes'}/>
                <div className="wpo-blog-items">
                    <div className="row">
                        {posts.map((blog, Bitem) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={Bitem}>
                                <div className="wpo-blog-item">
                                    <div className="wpo-blog-img">
                                        <img src={blog.imageprincipale} alt=""  width="296" 
        height="260"  />
                                        <div className="thumb">{blog.title}</div>
                                    </div>
                                    <div className="wpo-blog-content">
                                        <ul>
                                            <li>{blog.createdAt}</li>
                                            <li>By <Link onClick={ClickHandler} to={`/riads-renove/${blog.id}`}>Get Riad</Link></li>
                                        </ul>
                                        <h2><Link onClick={ClickHandler} to={`/riads-renove/${blog.id}`}>{blog.title}</Link></h2>
                                        <p>{blog.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="vector-1">
                <img src={bShape1} alt=""/>
            </div>
            <div className="vector-2">
                <img src={bShape2} alt=""/>
            </div>
        </section>
    )
}

export default BlogSectionS2;